<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('logs_action_title') }}</h3>

        <div class="g-content-filter-right">
          <a-form-model :model="searchForm" layout="inline" ref="formElement">
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="keyword">
              <a-input-search
                v-model="searchForm.keyword"
                style="min-width:200px"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="getList()"
              />
            </a-form-model-item>

            <!-- 开始时间 -->
            <a-form-model-item :label="null" prop="date" v-if="!['login'].includes(type)">
              <a-range-picker
                v-model="searchForm.date"
                show-time
                valueFormat="x"
                @openChange="
                  opened => {
                    if (!opened) {
                      this.getList();
                    }
                  }
                "
              />
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderField">
              <a-select
                v-model="searchForm.orderField"
                :placeholder="$t('com_form_order_field')"
                @change="getList()"
              >
                <!-- 0表示默认按主键，1按操作类型， 2按执行人，3按执行时间 -->
                <a-select-option
                  :value="item.value"
                  v-for="(item, index) in $t('logs_action_order_field')"
                  :key="index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderType">
              <a-select
                v-model="searchForm.orderType"
                :placeholder="$t('logs_order_type')"
                @change="getList()"
              >
                <a-select-option :value="1">
                  {{ $t('com_form_order_desc') }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ $t('com_form_order_esc') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 提交 -->
            <a-form-model-item style="margin:0">
              <a-button type="primary" @click.prevent="getList()">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="log-content">
        <!-- 用户导航 -->
        <div class="g-content-nav">
          <router-link
            :to="`/manage/system/logs/action/${listMapAuth[item].routeName}`"
            v-for="item in Object.keys(listMapAuth)"
            :key="item"
          >
            {{ listMapAuth[item].name }}
          </router-link>
        </div>

        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" />
        <div class="g-table" v-else>
          <!-- 登录 -->
          <LoginLogs :list="list" :loading="tableLoading" v-if="type === 'login'" />
          <!-- 客户 -->
          <CustomerLogs :list="list" :loading="tableLoading" v-else-if="type === 'customer'" />

          <!-- 设备操作 -->
          <DviceOperationLogs
            :list="list"
            :loading="tableLoading"
            v-else-if="type === 'device-basic'"
          />

          <!-- 设备命令 -->
          <DeviceCommand
            :list="list"
            :loading="tableLoading"
            v-else-if="type === 'device-command'"
          />

          <!-- 设备issue -->
          <DeviceIssue :list="list" :loading="tableLoading" v-else-if="type === 'device-issue'" />

          <!-- 设备模型 -->
          <DeviceModel :list="list" :loading="tableLoading" v-else-if="type === 'device-model'" />

          <!-- 站点 -->
          <Site :list="list" :loading="tableLoading" v-else-if="type === 'site'" />

          <!-- 用户 -->
          <User :list="list" :loading="tableLoading" v-else-if="type === 'user'" />

          <CommonLogs :list="list" :loading="tableLoading" v-else />
          <Pagination
            :current="pagination.current"
            :total="pagination.total"
            :pageSize.sync="pagination.pageSize"
            :callback="getList"
            @change="getList"
            v-if="pagination.total > 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/logs';
// 登录
import CommonLogs from './coponents/Common.vue';
import LoginLogs from './coponents/Login.vue';
import CustomerLogs from './coponents/Customer.vue';
import DviceOperationLogs from './coponents/DeviceOperation.vue';
import DeviceCommand from './coponents/DeviceCommand.vue';
import DeviceIssue from './coponents/DeviceIssue.vue';
import DeviceModel from './coponents/DeviceModel.vue';
import Site from './coponents/Site.vue';
import User from './coponents/User.vue';
import { mapGetters } from 'vuex';
import { dragTableToScroll } from '@/libs/utils';

export default {
  components: {
    CommonLogs,
    LoginLogs,
    CustomerLogs,
    DviceOperationLogs,
    DeviceCommand,
    DeviceIssue,
    DeviceModel,
    Site,
    User,
  },

  data() {
    return {
      networkError: false,
      type: 'login',
      loading: true,
      tableLoading: false,
      // 搜索
      searchForm: {
        keyword: '',
        orderField: 0,
        orderType: 1,
        date: undefined,
      },
      endOpen: false,

      // 列表
      list: [],
      columns: [],
      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      // api list
      listMap: {
        login: {
          api: API.LoginLog,
          name: this.$t('logs_action_list_login_event'),
          routeName: 'login',
          authKey: 'auth_logs_action_login',
        },
        customer: {
          api: API.CustomerActionLog,
          name: this.$t('logs_action_list_customer_event'),
          routeName: 'customer',
          authKey: 'auth_logs_action_customer',
        },
        'device-basic': {
          api: API.DeviceActionLog,
          name: this.$t('logs_action_list_device_operation_event'),
          routeName: 'device-basic',
          authKey: 'auth_logs_action_device_event',
        },
        'device-command': {
          api: API.DeviceOptLog,
          name: this.$t('logs_action_list_device_command_event'),
          routeName: 'device-command',
          authKey: 'auth_logs_action_device_command',
        },
        'device-issue': {
          api: API.DeviceIssueLog,
          name: this.$t('logs_action_list_device_issue'),
          routeName: 'device-issue',
          authKey: 'auth_logs_action_device_error',
        },
        'device-model': {
          api: API.DeviceModelLog,
          name: this.$t('logs_action_list_device_model'),
          routeName: 'device-model',
          authKey: 'auth_logs_actoion_device_model',
        },
        site: {
          api: API.SiteActionLog,
          name: this.$t('logs_action_list_site_event'),
          routeName: 'site',
          authKey: 'auth_logs_action_site',
        },
        user: {
          api: API.UserActionLog,
          name: this.$t('logs_action_list_user_event'),
          routeName: 'user',
          authKey: 'auth_logs_action_user',
        },
      },

      listMapAuth: {},

      horizontalScroll: null,
    };
  },

  watch: {
    searchForm: {
      handler(form) {
        if (form.date && !form.date.length) {
          // 日期清空时调用
          this.getList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },

  created() {
    // 权限
    const tabList = Object.keys(this.listMap);
    tabList.forEach(key => {
      const item = this.listMap[key];
      if ((item && this.authList.includes(item.authKey)) || this.isSuperAdmin) {
        this.listMapAuth[key] = item;
      }
    });

    this.type = this.$route.params.type;

    if (!this.type) {
      this.$router.replace({
        name: 'ActionLogList',
        params: {
          type: Object.keys(this.listMapAuth)[0],
        },
      });
      return;
    }
    this.getList();
  },

  beforeDestroy() {
    this.horizontalScrollDestory();
  },

  methods: {
    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      if (this.searchForm.date) {
        params.date = `${this.searchForm.date[0]}-${this.searchForm.date[1]}`;
      }

      this.tableLoading = true;
      this.networkError = false;

      // 是否有ID
      if (this.$route && this.$route && this.$route.params && this.$route.params.id) {
        params['id'] = this.$route.params.id;
      }

      // 获取列表
      this.listMap[this.type]
        ['api'](params)
        .then(res => {
          this.loadSuccess(res);
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loadComplete();

          // 表格横向滚动注册
          this.$nextTick(() => {
            this.horizontalScrollDestory();
            this.horizontalScroll = dragTableToScroll(
              document.querySelector('.ant-table-body'),
              document.querySelector('.ant-table-body table')
            );
          });
        });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScroll) {
        this.horizontalScroll.destroy();
      }
    },

    loadComplete() {
      this.$store.commit('setPageLoading', false);
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    disabledStartDate(startValue) {
      const endValue = this.searchForm.endTime;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.searchForm.startTime;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
